import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { PartnerServiceOfferDraftListItem } from '../../contracts/service-offer'

export const getPartnerServiceOfferDraftList = asBuilder((): { contents: PartnerServiceOfferDraftListItem[] } => {
  return {
    contents: faker.helpers.multiple(getPartnerServiceOfferDraftListItem),
  }
})

export const getPartnerServiceOfferDraftListItem = asBuilder((): PartnerServiceOfferDraftListItem => {
  return {
    id: faker.string.uuid(),
    storedAtUtc: faker.date.recent().toISOString(),
    title: faker.lorem.words(),
    thumbnail: {
      url: faker.image.url(),
    },
    treatments: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.lorem.word(),
    })),
  }
})
